import { render, staticRenderFns } from "./StudyDetailsForm.vue?vue&type=template&id=655b4181"
import script from "./StudyDetailsForm.vue?vue&type=script&lang=js"
export * from "./StudyDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports